(() => {
  if (customElements.get('navarambh-consultation')) return;
  customElements.define('navarambh-consultation', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (this.controller || !this.isConnected) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const form = this.querySelector('form');
      const floating = this.querySelector('.nvConsult__floating');
      if (floating) {
        const hiddenSections = [this, ...document.querySelectorAll('navarambh-hero .nvHero'), ...document.querySelectorAll('footer')];
        const syncFloating = () => {
          floating.hidden = hiddenSections.some(section => {
          const rect = section.getBoundingClientRect();
            return rect.top < window.innerHeight && rect.bottom > 0;
          });
        };
        syncFloating();
        if ('IntersectionObserver' in window) {
          this.floatingObserver = new IntersectionObserver(syncFloating, { threshold: 0 });
          hiddenSections.forEach(section => this.floatingObserver.observe(section));
        } else {
          window.addEventListener('scroll', syncFloating, { ...options, passive: true });
          window.addEventListener('resize', syncFloating, options);
        }
        floating.addEventListener('click', event => {
          event.preventDefault();
          form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          form.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true });
        }, options);
      }
      const city = form.querySelector('[name="Dropdown2"]');
      const store = form.querySelector('[name="Dropdown"]');
      this.storeGroups ||= [...store.querySelectorAll('optgroup')].map(group => group.cloneNode(true));
      const update = () => {
        const selected = store.value;
        const group = this.storeGroups.find(group => group.label === city.value);
        store.replaceChildren(new Option('Select nearest Limelight store', ''));
        if (group) store.append(group.cloneNode(true));
        store.disabled = !group;
        if ([...store.options].some(option => option.value === selected)) store.value = selected;
      };
      city.addEventListener('change', () => { store.value = ''; update(); }, options);
      form.addEventListener('reset', () => requestAnimationFrame(update), options);
      form.addEventListener('submit', event => {
        if (!city.value || !store.value) {
          event.preventDefault();
          (city.value ? store : city).reportValidity();
        }
      }, options);
      update();
      const params = new URLSearchParams(location.search);
      for (const name of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'zc_gad']) {
        form.elements.namedItem(name).value = params.get(name) || '';
      }
      if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); this.observer.unobserve(entry.target); }
      }), { threshold: .05, rootMargin: '0px 0px 40px 0px' });
      this.querySelectorAll('.nvConsult__reveal').forEach(element => this.observer.observe(element));
      this.classList.add('is-ready');
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.floatingObserver?.disconnect();
      this.classList.remove('is-ready');
    }
  });
})();